import { v4 as uuid } from 'uuid';
const DEVICE_ID_KEY = 'app-name-device-id';

export const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY) || '';
  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

export const removeDeviceId = () => {
  localStorage.removeItem(DEVICE_ID_KEY);
};

export const getPlatform = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/i.test(userAgent)) return 'Android';

  if (/iphone|ipad|ipod/.test(userAgent) || (userAgent.includes('mac') && 'ontouchend' in document)) return 'iOS';

  if (/windows/i.test(userAgent)) return 'Windows';

  if (userAgent.includes('mac')) return 'Mac';

  return 'Other';
};

export async function hashString(input) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function createFingerprint() {
  const components = [
    navigator.userAgent,
    navigator.language,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    window.devicePixelRatio,
    'ontouchstart' in window ? 'touch' : 'no-touch',
  ];

  // Add canvas fingerprinting
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText('fingerprint', 2, 2);
  const canvasData = canvas.toDataURL();
  components.push(canvasData);
  // Join all data with a separator
  const fingerprintData = components.join('||');

  const hash = await hashString(fingerprintData);

  console.log(fingerprintData);
  console.log('Browser hash:', hash);
  return hash;
}

/**
 * Dispatch game event helper
 * @param {Object} payload - Event payload
 */
export const dispatchGameEvent = (payload) => {
  if (typeof window.dispatchGameMessageEvent === 'function') {
    window.dispatchGameMessageEvent(payload);
  }
};
